import React, { useState, useEffect } from "react";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import axios from "../Axios";

export function DDIssueType(props) {
    const [TOS, SeTOS] = useState([]);
    const GetIssueDetails = async () => {
        try {
            const res = await axios.get("/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=0&LovCategoryId=78&ParentLovId=0&LanguageId=0");
            const Formatdata = res.data.map((item) => ({ value: item.lovId, display: item.lovDescription }));
            SeTOS(Formatdata);
        }
        catch (error) { console.log(error); }
        finally { }
    }
    useEffect(() => { GetIssueDetails(); }, []);
    return (
        <DropdownValues Displayname={props.Displayname} className={props.className} options={TOS}
            disabled={props.disable} selectoption={props.SOption} onChange={(e) => props.onChange(e.target.value)}
            labelname={<div className="DropdownHeader"> Type of Issue<span>*</span> </div>} />
    )
}

export function StageDD(props) {
    const [Options, SetOptions] = useState();
    const GetStage = async () => {
        await axios.get(process.env.REACT_APP_API_BASE_URL +
            `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=0`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                const Options = res.data.map((item) => ({
                    display: item.lovDescription, value: item.lovId,
                }));
                SetOptions(Options);
                props.StoreMSource(props.SOption || "");
            })
            .catch((err) => { console.log(err); });
    };

    useEffect(() => { GetStage(); }, []);

    return (
        <DropdownValues Displayname={props.Displayname} className={props.className}
            options={Options} selectoption={props.SOption} onChange={(e) => props.onChange(e.target.value)}
            disabled={props.disable} labelname={props.labelname} />
    );
}
export function CircularGoalDD(props) {
    const [Options, SetOptions] = useState();
    const GetCGoal = async () => {
        await axios.get(process.env.REACT_APP_API_BASE_URL +
            `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=${props.PId}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                const Options = res.data.map((item) => ({
                    display: item.lovName, value: item.lovId,
                }));
                props.GetDetails(res.data);
                SetOptions(Options);
                // if (parseInt(props.PId) === 3307) {
                //     props.StoreValue(res.data[0]?.lovId );
                // } else {
                props.StoreMSource(props.SOption || "");
                // }
            })
            .catch((err) => { console.log(err); });
    };

    useEffect(() => { GetCGoal(); }, [props.PId]);

    return (
        <DropdownValues Displayname={props.Displayname} className={props.className}
            options={Options} selectoption={props.SOption} onChange={(e) => props.onChange(e.target.value)}
            disabled={props.disable} labelname={props.labelname} />
    );
}

export function CompetenciesDD(props) {
    const [Options, SetOptions] = useState();
    const GetCompetencies = async () => {
        await axios.get(process.env.REACT_APP_API_BASE_URL +
            `/NCLAdmin/GetLovByCategoryOrParentLov?SubjectId=${props.SID}&LovCategoryId=${props.LID}&ParentLovId=${props.PId}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                const Options = res.data.map((item) => ({
                    display: item.lovName, value: item.lovId,
                }));
                props.GetDetails(res.data);
                SetOptions(Options);
                props.StoreMSource(props.SOption || "");
            })
            .catch((err) => { console.log(err); });
    };

    useEffect(() => { GetCompetencies(); }, [props.PId]);

    return (
        <DropdownValues Displayname={props.Displayname} className={props.className}
            options={Options} selectoption={props.SOption} onChange={(e) => props.onChange(e.target.value)}
            disabled={props.disable} labelname={props.labelname} />
    );
}